import React, { createContext, useState } from "react";
import {SuperOrder} from "@beeldit/ecommerce/super-orders/models/SuperOrder";

interface EditBillingAddressActionContextType {
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;    
  element: SuperOrder;
  setElement: (element: any) => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}

export const EditBillingAddressActionContext = createContext<EditBillingAddressActionContextType>({
  backendFormErrors: {},
  setBackendFormErrors: () => {},  
  element: new SuperOrder(),
  setElement: () => {},
  showModal: false,
  setShowModal: () => {},

});

interface EditBillingAddressActionProviderProps {
  children: React.ReactNode;
}

export const EditBillingAddressActionProvider: React.FC<EditBillingAddressActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [element, setElement] = useState<SuperOrder>(new SuperOrder());
  const [showModal, setShowModal] = useState(false);

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    element,
    setElement,
    showModal,
    setShowModal,
  };
  return (
    <EditBillingAddressActionContext.Provider value={value}>
      {children}
    </EditBillingAddressActionContext.Provider>
  );
};
